import React from 'react';
import {Route,Redirect} from 'react-router-dom';
import {connect} from "react-redux";

const PrivateRoute = ({component : Component,...rest})=>{
    const logInState = rest.isUserLoggedIn;
    return(
    <Route {...rest} render={
        props=>(
           logInState ? <Component {...props}/> : <Redirect to="/login"/>
    )}/>)
};

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

export default connect(mapStateToProps)(PrivateRoute);